import type {
	AppConfig,
	AppConfigMap,
	AppConfigNamespace
} from '../types/app-config.types';

export function pickAppConfig<TNamespace extends AppConfigNamespace>(
	config: AppConfig,
	namespace: TNamespace
): Partial<AppConfigMap[TNamespace]> {
	return (config[namespace] ?? {}) as Partial<AppConfigMap[TNamespace]>;
}
